import { MarkdownEditor } from "@/components/markdown-editor/MarkdownEditor";
import { MarkdownPreview } from "@/components/markdown-editor/MarkdownPreview";
import { toMarkdown } from "./project-description-utils";

export function ProjectDescriptionPreview({
	value,
	className,
	fallback = "No description.",
}: {
	value: string | null | undefined;
	className?: string;
	fallback?: string;
}) {
	if (!value) return <span className={className}>{fallback}</span>;
	return <MarkdownPreview source={toMarkdown(value)} className={className} />;
}

export function ProjectDescriptionEditor({
	value,
	onChange,
	placeholder = "Describe the project goals and scope...",
	autoFocus = false,
	onBlur,
	className,
}: {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	autoFocus?: boolean;
	onBlur?: () => void;
	className?: string;
}) {
	return (
		<MarkdownEditor
			value={toMarkdown(value)}
			onChange={onChange}
			placeholder={placeholder}
			autoFocus={autoFocus}
			onBlur={onBlur}
			className={className}
		/>
	);
}
